import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  AfterViewInit,
} from '@angular/core';
import { AdminService } from 'src/app/services/admin/admin.service';
import { LanguagesService } from 'src/app/services/languages/languages.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.css'],
})
export class LanguageSelectorComponent implements AfterViewInit {
  @Input() appId = 0;
  @Output() languageChanged = new EventEmitter<string>();
  @Input() showName = true;
  @Input() style = true;

  selectedLanguage: string = '';
  availableLanguages: any[] = [];
  load = false;
  error = false;

  private modalService: NgbModal;
  modalRef: NgbModalRef | null = null;

  constructor(
    private LanguagesService: LanguagesService,
    private cd: ChangeDetectorRef,
    private adminService: AdminService,
    modalService: NgbModal
  ) {
    this.modalService = modalService;
  }

ngOnInit(): void {
  this.LanguagesService
    .productCategoryLanguage$
    .subscribe((lang: string) => {

      if (lang) {
        this.selectedLanguage = lang;
      }

      this.cd.detectChanges();
    });

  this.getLanguages();
}

  open(content: TemplateRef<any>) {
    this.modalRef = this.modalService.open(content, {
      backdropClass: 'light-blue-backdrop',
      size: 'sm',
      scrollable: true,
    });
  }

  ngAfterViewInit(): void {
    // სხვა ოპერაციები საჭიროების შემთხვევაში
  }

getLanguages(): void {
  this.load = true;
  this.error = false;

  this.LanguagesService.getUserLanguages(
    this.adminService.user.id.toString(),
    this.appId.toString()
  ).subscribe({
    next: (res: any) => {
      this.load = false;

      this.availableLanguages =
        (res?.languages || []).filter(
          (lang: any) => lang.action !== false
        );

      if (this.availableLanguages.length === 0) {
        this.selectedLanguage = '';

        this.LanguagesService
          .clearProductCategoryLanguage();

        this.cd.detectChanges();

        return;
      }

      /*
       * 1. ჯერ ვეძებთ საიტის default ენას.
       */
      const defaultLanguage =
        this.availableLanguages.find(
          (lang: any) => lang.default === true
        );

      /*
       * 2. თუ უკვე არჩეული ენა ამ საიტისთვის
       * ისევ აქტიურია, შეგვიძლია დავტოვოთ.
       */
      const currentLanguage =
        this.availableLanguages.find(
          (lang: any) =>
            lang.code === this.selectedLanguage
        );

      /*
       * პრიორიტეტი:
       *
       * მიმდინარე valid ენა
       * →
       * საიტის default ენა
       * →
       * პირველი active ენა
       */
      const language =
        currentLanguage ||
        defaultLanguage ||
        this.availableLanguages[0];

      this.selectedLanguage =
        language.code;

      this.LanguagesService
        .setProductCategoryLanguageSource(
          this.selectedLanguage
        );

      this.languageChanged.emit(
        this.selectedLanguage
      );

      this.cd.detectChanges();
    },

    error: (error) => {
      this.load = false;
      this.error = true;

      console.error(
        'Error loading website languages:',
        error
      );

      this.cd.detectChanges();
    }
  });
}

selLang(languageCode: string): void {

  const languageExists =
    this.availableLanguages.some(
      lang => lang.code === languageCode
    );

  if (!languageCode || !languageExists) {
    return;
  }

  this.selectedLanguage = languageCode;

  this.LanguagesService
    .setProductCategoryLanguageSource(
      languageCode
    );

  this.languageChanged.emit(
    languageCode
  );

  this.modalRef?.close();

  this.cd.detectChanges();
}

  getLanguageName(code: string): any {
    const lang = this.availableLanguages.find((l) => l.code === code);
    return lang || { name: 'იძებნება ენა', img: 'default-lang-img.png' };
  }
}